import { PrismicRichText, PrismicLink } from '@prismicio/react';
import React from 'react';
import CardGeneric from 'src/components/Card/CardGeneric';
import styles from './reasons-to-choose.module.scss';
import { Content } from '@prismicio/client';

type CardProps = { item: Content.ReasonsToChooseSliceDefaultItem };

export const Card = ({ item }: CardProps) => {
    const image = {
        src: item?.image?.url ?? '',
        width: item?.image?.dimensions?.width,
        height: item?.image?.dimensions?.height,
        alt: item?.image?.alt ?? 'image',
    };
    return (
        <CardGeneric image={image} className="!h-auto min-w-[264px]">
            <div className={styles['card-content-wrapper']}>
                <div className="mb-4 flex flex-col gap-3 md:gap-4">
                    <p className={styles['card-header']}>{item.header}</p>
                    <div className={styles['card-rich-text']}>
                        <PrismicRichText field={item.description} />
                    </div>
                </div>
                <PrismicLink field={item.link} className={styles['card-link']}>
                    {item.link_label}
                </PrismicLink>
            </div>
        </CardGeneric>
    );
};
